export class AppMode {
  appModeId: string;
  code: string;
  name: string;
  deleted: number;

  constructor(obj: Params = {}) {
    this.appModeId = obj.appModeId;
    this.code = obj.code;
    this.name = obj.name;
    this.deleted = obj.deleted;
  }
}

type Params = Partial<{
  appModeId: string;
  code: string;
  name: string;
  deleted: number;
}>;

export enum AppModeCode {
  MAX = 'MAX',
  DENT = 'DENT',
  ENT = 'ENT',
  MED = 'MED',
  VET = 'VET',
  '2D' = '2D',
  '2DVET' = '2DVET',
}
